(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ja-product-landing-faq"] && !Shopify.designMode) return;
  try {
    
  class JaResponsiveFaq extends HTMLElement {
    connectedCallback() {
      if (!this.details) {
        this.question = this.querySelector('.ja-product-faq__question');
        this.answer = this.querySelector('.ja-product-faq__answer');
        const template = this.querySelector('template');
        if (!this.question || !template) return;
        this.details = template.content.firstElementChild.cloneNode(true);
        this.summary = this.details.querySelector('summary');
        template.remove();
      }

      this.mobileQuery = window.matchMedia('(max-width: 749px)');
      this.onBreakpointChange = () => this.updateLayout();
      this.mobileQuery.addEventListener('change', this.onBreakpointChange);
      this.updateLayout();
    }

    disconnectedCallback() {
      this.mobileQuery?.removeEventListener('change', this.onBreakpointChange);
    }

    updateLayout() {
      const activeElement = document.activeElement;
      const answerHadFocus = this.answer?.contains(activeElement);

      if (this.mobileQuery.matches) {
        this.summary.prepend(this.question);
        if (this.answer) this.details.append(this.answer);
        this.append(this.details);
        if (answerHadFocus) this.details.open = true;
        if (activeElement === this.question) this.summary.focus();
      } else {
        this.append(this.question);
        if (this.answer) this.append(this.answer);
        this.details.remove();
        if (activeElement === this.summary) {
          this.question.setAttribute('tabindex', '-1');
          this.question.addEventListener('blur', () => this.question.removeAttribute('tabindex'), { once: true });
          this.question.focus();
        }
      }

      if (answerHadFocus) activeElement.focus();
    }
  }

  if (!customElements.get('ja-responsive-faq')) {
    customElements.define('ja-responsive-faq', JaResponsiveFaq);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ja-yotpo-curated-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const requestCache = window.JAYotpoCuratedReviewRequests || new Map();
    window.JAYotpoCuratedReviewRequests = requestCache;

    const createElement = (tag, className, text) => {
      const element = document.createElement(tag);
      if (className) element.className = className;
      if (text !== undefined && text !== null) element.textContent = text;
      return element;
    };

    const createStar = (className) => {
      const namespace = 'http://www.w3.org/2000/svg';
      const star = document.createElementNS(namespace, 'svg');
      const shape = document.createElementNS(namespace, 'polygon');

      star.setAttribute('class', className);
      star.setAttribute('viewBox', '0 0 20 20');
      star.setAttribute('aria-hidden', 'true');
      star.setAttribute('focusable', 'false');
      shape.setAttribute('points', '10,2 12.45,7.1 18,7.9 13.95,11.75 15,17.3 10,14.6 5,17.3 6.05,11.75 2,7.9 7.55,7.1');
      star.append(shape);

      return star;
    };

    const fetchReviews = (url) => {
      if (requestCache.has(url)) return requestCache.get(url);

      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 8000);
      const request = fetch(url, {
        credentials: 'omit',
        headers: { Accept: 'application/json' },
        signal: controller.signal,
      })
        .then((response) => {
          if (!response.ok) throw new Error(`Yotpo request failed: ${response.status}`);
          return response.json();
        })
        .catch((error) => {
          requestCache.delete(url);
          throw error;
        })
        .finally(() => window.clearTimeout(timeout));

      requestCache.set(url, request);
      return request;
    };

    const normalizeResponse = (payload, sourceProduct, type) => {
      const response = payload && payload.response;
      if (!response || !Array.isArray(response.reviews)) return [];

      const products = Array.isArray(response.products) ? response.products : [];
      const productByInternalId = new Map(products.map((item) => [String(item.id), item]));

      return response.reviews
        .map((review) => {
          const apiProduct = productByInternalId.get(String(review.product_id));
          const score = Number(review.score);
          const createdAt = typeof review.created_at === 'string' ? review.created_at : null;

          return {
            id: review.id === undefined || review.id === null ? null : String(review.id),
            score: Number.isFinite(score) ? score : 0,
            title: typeof review.title === 'string' ? review.title.trim() : '',
            content: typeof review.content === 'string' ? review.content.trim() : '',
            reviewerName: typeof review.user?.display_name === 'string' ? review.user.display_name.trim() : '',
            verified: Boolean(review.verified_buyer),
            createdAt,
            productId: sourceProduct?.id ? String(sourceProduct.id) : apiProduct?.domain_key ? String(apiProduct.domain_key) : null,
            productTitle: sourceProduct?.title || apiProduct?.name || null,
            type,
          };
        })
        .filter((review) => review.id && review.score > 0 && (review.title || review.content));
    };

    const dedupeReviews = (reviews) => {
      const unique = new Map();
      reviews.forEach((review) => {
        if (!unique.has(review.id)) unique.set(review.id, review);
      });
      return Array.from(unique.values());
    };

    const eligibleReviews = (reviews, config) => {
      const minimumContentLength = Math.max(0, Number(config.minimumContentLength || 0));
      const minimumRating = Math.max(0, Number(config.minimumRating || 0));

      return dedupeReviews(reviews)
        .filter((review) => review.content.length >= minimumContentLength)
        .filter((review) => review.score >= minimumRating);
    };

    class JAYotpoCuratedReviews extends HTMLElement {
      connectedCallback() {
        if (this.initialized) {
          if (!this.loading) this.loadWhenNearViewport();
          return;
        }
        this.initialized = true;

        const configElement = this.querySelector('[data-yotpo-curated-reviews-config]');
        try {
          this.config = JSON.parse(configElement?.textContent || '{}');
        } catch (error) {
          this.finish([]);
          return;
        }

        if (!this.config.sourceValid || !this.config.storeId) {
          this.setAttribute('aria-busy', 'false');
          return;
        }

        this.loadWhenNearViewport();
      }

      disconnectedCallback() {
        this.loadObserver?.disconnect();
        this.loadObserver = null;
      }

      loadWhenNearViewport() {
        if (this.loading || this.loadObserver) return;

        if (this.config.designMode || !('IntersectionObserver' in window)) {
          this.load();
          return;
        }

        this.loadObserver = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;

            this.loadObserver?.disconnect();
            this.loadObserver = null;
            this.load();
          },
          { rootMargin: '800px 0px' }
        );
        this.loadObserver.observe(this);
      }

      async load() {
        if (this.loading) return;
        this.loading = true;

        try {
          const curatedReviews = await this.loadCuratedReviews();
          const reviews = eligibleReviews(curatedReviews, this.config).slice(
            0,
            Number(this.config.maximumReviews || 12)
          );
          this.finish(reviews);
        } catch (error) {
          this.finish([]);
        }
      }

      async loadCuratedReviews() {
        if (!Array.isArray(this.config.selections) || this.config.selections.length === 0) return [];

        const selectionsBySource = new Map();
        this.config.selections.forEach((selection) => {
          const sourceId = String(selection.sourceId || '');
          const reviewId = String(selection.id || '');
          if (!sourceId || !reviewId) return;

          if (!selectionsBySource.has(sourceId)) selectionsBySource.set(sourceId, []);
          selectionsBySource.get(sourceId).push({ ...selection, sourceId, id: reviewId });
        });

        const sourceRequests = Array.from(selectionsBySource.entries()).map(([sourceId, selections]) =>
          this.loadReviewSource(sourceId, selections)
        );
        const sourceResults = await Promise.allSettled(sourceRequests);
        const reviewsBySelection = new Map();

        sourceResults.forEach((result) => {
          if (result.status !== 'fulfilled') return;
          result.value.forEach((review) => {
            reviewsBySelection.set(`${review.sourceId}:${review.id}`, review);
          });
        });

        return this.config.selections
          .map((selection) => {
            const key = `${String(selection.sourceId || '')}:${String(selection.id || '')}`;
            const review = reviewsBySelection.get(key);
            if (!review) return null;

            return {
              ...review,
              blockId: selection.blockId || null,
              productTitle: selection.sourceTitle || review.productTitle,
              type: selection.type || review.type,
            };
          })
          .filter(Boolean);
      }

      async loadReviewSource(sourceId, selections) {
        const baseUrl = `https://api-cdn.yotpo.com/v1/widget/${encodeURIComponent(this.config.storeId)}/products`;
        const requiredIds = new Set(selections.map((selection) => String(selection.id)));
        const sourceProduct = {
          id: sourceId,
          title: selections[0]?.sourceTitle || null,
        };
        const type = selections[0]?.type || 'product';
        const perPage = 150;
        const maximumPages = 10;
        const reviews = [];
        let loadedReviewCount = 0;
        const hasAllRequiredReviews = () =>
          Array.from(requiredIds).every((id) => reviews.some((review) => review.id === id));

        for (let page = 1; page <= maximumPages; page += 1) {
          const query = `page=${page}&per_page=${perPage}&sort=date&direction=desc`;
          let payload;

          try {
            payload = await fetchReviews(`${baseUrl}/${encodeURIComponent(sourceId)}/reviews.json?${query}`);
          } catch (error) {
            if (page === 1) throw error;
            break;
          }

          const pageReviews = normalizeResponse(payload, sourceProduct, type).map((review) => ({
            ...review,
            sourceId,
          }));
          const rawReviewCount = Array.isArray(payload?.response?.reviews) ? payload.response.reviews.length : 0;
          const totalReviews = Number(payload?.response?.pagination?.total);

          reviews.push(...pageReviews);
          loadedReviewCount += rawReviewCount;

          if (hasAllRequiredReviews()) break;
          if (Number.isFinite(totalReviews) && loadedReviewCount >= totalReviews) break;
          if (rawReviewCount === 0) break;
          if (!Number.isFinite(totalReviews) && rawReviewCount < perPage) break;
        }

        if (!hasAllRequiredReviews()) {
          const fallbackPerPage = 20;

          for (let page = 1; page <= maximumPages; page += 1) {
            const query = `page=${page}&per_page=${fallbackPerPage}&sort=date&direction=desc`;
            let payload;

            try {
              payload = await fetchReviews(`${baseUrl}/${encodeURIComponent(sourceId)}/reviews.json?${query}`);
            } catch (error) {
              break;
            }

            const pageReviews = normalizeResponse(payload, sourceProduct, type).map((review) => ({
              ...review,
              sourceId,
            }));
            const rawReviewCount = Array.isArray(payload?.response?.reviews) ? payload.response.reviews.length : 0;

            reviews.push(...pageReviews);

            if (hasAllRequiredReviews()) break;
            if (rawReviewCount === 0) break;
          }
        }

        return reviews.filter((review) => requiredIds.has(review.id));
      }

      finish(reviews) {
        const grid = this.querySelector('[data-review-grid]');
        const status = this.querySelector('[data-review-status]');
        const sliderTemplate = this.querySelector('[data-review-slider-template]');
        const cta = this.querySelector('[data-review-cta]');
        this.setAttribute('aria-busy', 'false');

        if (!grid || reviews.length === 0) {
          if (status) status.textContent = this.config?.text?.noReviews || '';
          if (!this.config?.designMode) {
            this.hidden = true;
            const section = this.closest('.ja-yotpo-curated-reviews-section');
            section?.setAttribute('hidden', '');
          }
          if (grid) grid.replaceChildren();
          return;
        }

        const sliderContent = sliderTemplate?.content.cloneNode(true);
        const slider = sliderContent?.querySelector('slideshow-component');
        const track = sliderContent?.querySelector('slideshow-slides');

        if (!sliderContent || !slider || !track) {
          if (status) status.textContent = this.config?.text?.unavailable || '';
          return;
        }

        track.setAttribute('role', 'list');
        reviews.forEach((review, index) => {
          const slide = createElement('slideshow-slide', 'ja-yotpo-curated-reviews__slide');
          slide.setAttribute('ref', 'slides[]');
          slide.setAttribute('role', 'listitem');
          slide.setAttribute('aria-hidden', index === 0 ? 'false' : 'true');
          slide.setAttribute('slide-id', `review-${review.id}`);
          slide.style.setProperty('--slideshow-timeline', `--slide-${index}`);
          slide.append(this.renderReview(review));
          track.append(slide);
        });

        slider.style.setProperty(
          '--slideshow-timeline',
          reviews.map((_, index) => `--slide-${index}`).join(', ')
        );
        slider.classList.toggle('ja-yotpo-curated-reviews__carousel--fits-desktop', reviews.length <= 3);

        if (reviews.length <= 1) slider.querySelector('slideshow-arrows')?.remove();

        grid.replaceWith(sliderContent);
        if (cta) cta.hidden = false;
        if (status) status.textContent = '';
      }

      truncateContent(content, limit) {
        if (content.length <= limit) return content;

        const candidate = content.slice(0, limit + 1);
        const lastSpace = candidate.lastIndexOf(' ');
        const cutoff = lastSpace >= Math.floor(limit * 0.6) ? lastSpace : limit;
        return `${content.slice(0, cutoff).trimEnd()}...`;
      }

      renderReview(review) {
        const card = createElement('article', `ja-yotpo-curated-reviews__card ${this.config.cardColorScheme || ''}`);
        if (review.blockId) card.dataset.reviewBlockId = review.blockId;

        const rating = createElement('div', 'ja-yotpo-curated-reviews__stars');
        const roundedScore = Math.max(1, Math.min(5, Math.round(review.score)));
        rating.setAttribute('aria-label', (this.config.text.stars || '__score__ out of 5 stars').replace('__score__', String(review.score)));

        for (let index = 1; index <= 5; index += 1) {
          const className = index <= roundedScore ? 'ja-yotpo-curated-reviews__star' : 'ja-yotpo-curated-reviews__star ja-yotpo-curated-reviews__star--empty';
          rating.append(createStar(className));
        }
        card.append(rating);

        if (this.config.showTitle && review.title) {
          card.append(createElement('h3', 'ja-yotpo-curated-reviews__title', review.title));
        }

        const copy = createElement('div', 'ja-yotpo-curated-reviews__copy');
        const content = createElement('blockquote', 'ja-yotpo-curated-reviews__content', review.content);
        const readMoreLimit = Math.max(1, Number(this.config.readMoreCharacterLimit || 220));
        const canCollapse = Boolean(this.config.enableReadMore) && review.content.length > readMoreLimit;

        if (canCollapse) {
          const collapsedContent = this.truncateContent(review.content, readMoreLimit);
          const contentId = `YotpoReviewContent-${String(this.config.sectionId || 'section').replace(/[^A-Za-z0-9_-]/g, '-')}-${review.id}`;
          const toggle = createElement('button', 'ja-yotpo-curated-reviews__read-more', this.config.text.readMore);
          let expanded = false;

          copy.classList.add('ja-yotpo-curated-reviews__copy--collapsible');
          content.id = contentId;
          content.textContent = collapsedContent;
          toggle.type = 'button';
          toggle.setAttribute('aria-controls', contentId);
          toggle.setAttribute('aria-expanded', 'false');
          toggle.addEventListener('mousedown', (event) => event.stopPropagation());
          toggle.addEventListener('pointerdown', (event) => event.stopPropagation());
          toggle.addEventListener('touchstart', (event) => event.stopPropagation(), { passive: true });
          toggle.addEventListener('click', () => {
            expanded = !expanded;
            content.textContent = expanded ? review.content : collapsedContent;
            toggle.textContent = expanded ? this.config.text.readLess : this.config.text.readMore;
            toggle.setAttribute('aria-expanded', String(expanded));
          });

          copy.append(content, toggle);
        } else {
          copy.append(content);
        }

        card.append(copy);

        const footer = createElement('footer', 'ja-yotpo-curated-reviews__footer');
        const meta = createElement('p', 'ja-yotpo-curated-reviews__meta');

        if (this.config.showReviewerName && review.reviewerName) {
          meta.append(createElement('span', 'ja-yotpo-curated-reviews__meta-item ja-yotpo-curated-reviews__reviewer', review.reviewerName));
        }

        if (this.config.showVerifiedStatus && review.verified) {
          meta.append(createElement('span', 'ja-yotpo-curated-reviews__meta-item ja-yotpo-curated-reviews__verified', this.config.text.verified));
        }

        if (this.config.showDate && review.createdAt) {
          const date = new Date(review.createdAt);
          if (!Number.isNaN(date.getTime())) {
            const formattedDate = new Intl.DateTimeFormat(this.config.locale || document.documentElement.lang || 'en', {
              day: 'numeric',
              month: 'short',
              year: 'numeric',
            }).format(date);
            const time = createElement('time', 'ja-yotpo-curated-reviews__meta-item', formattedDate);
            time.dateTime = review.createdAt;
            meta.append(time);
          }
        }

        if (meta.childElementCount > 0) footer.append(meta);

        if (this.config.showProductName && review.productTitle) {
          footer.append(createElement('p', 'ja-yotpo-curated-reviews__product', review.productTitle));
        }

        if (footer.childElementCount > 0) card.append(footer);
        return card;
      }
    }

    if (!customElements.get('ja-yotpo-curated-reviews')) {
      customElements.define('ja-yotpo-curated-reviews', JAYotpoCuratedReviews);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ja-yotpo-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const requestCache = window.JAYotpoReviewRequests || new Map();
    window.JAYotpoReviewRequests = requestCache;

    const createElement = (tag, className, text) => {
      const element = document.createElement(tag);
      if (className) element.className = className;
      if (text !== undefined && text !== null) element.textContent = text;
      return element;
    };

    const createStar = (className) => {
      const namespace = 'http://www.w3.org/2000/svg';
      const star = document.createElementNS(namespace, 'svg');
      const shape = document.createElementNS(namespace, 'polygon');

      star.setAttribute('class', className);
      star.setAttribute('viewBox', '0 0 20 20');
      star.setAttribute('aria-hidden', 'true');
      star.setAttribute('focusable', 'false');
      shape.setAttribute('points', '10,2 12.45,7.1 18,7.9 13.95,11.75 15,17.3 10,14.6 5,17.3 6.05,11.75 2,7.9 7.55,7.1');
      star.append(shape);

      return star;
    };

    const fetchReviews = (url) => {
      if (requestCache.has(url)) return requestCache.get(url);

      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 8000);
      const request = fetch(url, {
        credentials: 'omit',
        headers: { Accept: 'application/json' },
        signal: controller.signal,
      })
        .then((response) => {
          if (!response.ok) throw new Error(`Yotpo request failed: ${response.status}`);
          return response.json();
        })
        .catch((error) => {
          requestCache.delete(url);
          throw error;
        })
        .finally(() => window.clearTimeout(timeout));

      requestCache.set(url, request);
      return request;
    };

    const normalizeResponse = (payload, sourceProduct, type) => {
      const response = payload && payload.response;
      if (!response || !Array.isArray(response.reviews)) return [];

      const products = Array.isArray(response.products) ? response.products : [];
      const productByInternalId = new Map(products.map((item) => [String(item.id), item]));

      return response.reviews
        .map((review) => {
          const apiProduct = productByInternalId.get(String(review.product_id));
          const score = Number(review.score);
          const createdAt = typeof review.created_at === 'string' ? review.created_at : null;

          return {
            id: review.id === undefined || review.id === null ? null : String(review.id),
            score: Number.isFinite(score) ? score : 0,
            title: typeof review.title === 'string' ? review.title.trim() : '',
            content: typeof review.content === 'string' ? review.content.trim() : '',
            reviewerName: typeof review.user?.display_name === 'string' ? review.user.display_name.trim() : '',
            verified: Boolean(review.verified_buyer),
            createdAt,
            productId: sourceProduct?.id ? String(sourceProduct.id) : apiProduct?.domain_key ? String(apiProduct.domain_key) : null,
            productTitle: sourceProduct?.title || apiProduct?.name || null,
            type,
          };
        })
        .filter((review) => review.id && review.score > 0 && (review.title || review.content));
    };

    const dedupeReviews = (reviews) => {
      const unique = new Map();
      reviews.forEach((review) => {
        if (!unique.has(review.id)) unique.set(review.id, review);
      });
      return Array.from(unique.values());
    };

    const eligibleReviews = (reviews, config) => {
      const minimumContentLength = Math.max(0, Number(config.minimumContentLength || 0));
      const minimumRating = Math.max(0, Number(config.minimumRating || 0));

      return dedupeReviews(reviews)
        .filter((review) => review.content.length >= minimumContentLength)
        .filter((review) => review.score >= minimumRating);
    };

    class JAYotpoReviews extends HTMLElement {
      connectedCallback() {
        if (this.initialized) {
          if (!this.loading) this.loadWhenNearViewport();
          return;
        }
        this.initialized = true;

        const configElement = this.querySelector('[data-yotpo-reviews-config]');
        try {
          this.config = JSON.parse(configElement?.textContent || '{}');
        } catch (error) {
          this.finish([]);
          return;
        }

        if (!this.config.sourceValid || !this.config.storeId) {
          this.setAttribute('aria-busy', 'false');
          return;
        }

        this.loadWhenNearViewport();
      }

      disconnectedCallback() {
        this.loadObserver?.disconnect();
        this.loadObserver = null;
      }

      loadWhenNearViewport() {
        if (this.loading || this.loadObserver) return;

        if (this.config.designMode || !('IntersectionObserver' in window)) {
          this.load();
          return;
        }

        this.loadObserver = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;

            this.loadObserver?.disconnect();
            this.loadObserver = null;
            this.load();
          },
          { rootMargin: '800px 0px' }
        );
        this.loadObserver.observe(this);
      }

      async load() {
        if (this.loading) return;
        this.loading = true;

        try {
          const automaticReviews = await this.loadAutomaticReviews();
          const featuredReviews = [];
          let reviews = eligibleReviews([...featuredReviews, ...automaticReviews], this.config).sort(
            (left, right) => this.timestamp(right.createdAt) - this.timestamp(left.createdAt)
          );

          if (!this.config.showAllReviews) {
            reviews = reviews.slice(0, Number(this.config.maximumReviews || 6));
          }

          this.finish(reviews);
        } catch (error) {
          this.finish([]);
        }
      }

      async loadAutomaticReviews() {
        const baseUrl = `https://api-cdn.yotpo.com/v1/widget/${encodeURIComponent(this.config.storeId)}/products`;
        const showAllReviews = Boolean(this.config.showAllReviews);
        const maximumReviews = Math.max(1, Number(this.config.maximumReviews || 6));
        const perPage = showAllReviews ? 150 : 20;
        const maximumPages = showAllReviews ? 20 : 5;
        if (!Array.isArray(this.config.products) || this.config.products.length === 0) return [];

        const sourceProduct = this.config.products[0];
        const productId = encodeURIComponent(String(sourceProduct.id));
        const reviews = [];
        let loadedReviewCount = 0;
        let reportedTotalReviews = null;

        for (let page = 1; page <= maximumPages; page += 1) {
          const query = `page=${page}&per_page=${perPage}&sort=date&direction=desc`;
          let payload;

          try {
            payload = await fetchReviews(`${baseUrl}/${productId}/reviews.json?${query}`);
          } catch (error) {
            if (page === 1) throw error;
            break;
          }

          if (page === 1) this.updateRatingSummary(payload?.response?.bottomline);

          const pageReviews = normalizeResponse(payload, sourceProduct, 'product');
          const rawReviewCount = Array.isArray(payload?.response?.reviews) ? payload.response.reviews.length : 0;
          const totalReviews = Number(payload?.response?.pagination?.total);

          if (Number.isFinite(totalReviews)) reportedTotalReviews = totalReviews;

          reviews.push(...pageReviews);
          loadedReviewCount += rawReviewCount;

          if (!showAllReviews && eligibleReviews(reviews, this.config).length >= maximumReviews) break;
          if (Number.isFinite(totalReviews) && loadedReviewCount >= totalReviews) break;
          if (rawReviewCount === 0) break;
          if (!Number.isFinite(totalReviews) && rawReviewCount < perPage) break;
        }

        if (showAllReviews && Number.isFinite(reportedTotalReviews)) {
          const fallbackPerPage = 20;
          const uniqueReviewCount = dedupeReviews(reviews).length;

          if (uniqueReviewCount < reportedTotalReviews) {
            for (let page = 1; page <= maximumPages; page += 1) {
              const query = `page=${page}&per_page=${fallbackPerPage}&sort=date&direction=desc`;
              let payload;

              try {
                payload = await fetchReviews(`${baseUrl}/${productId}/reviews.json?${query}`);
              } catch (error) {
                break;
              }

              const pageReviews = normalizeResponse(payload, sourceProduct, 'product');
              const rawReviewCount = Array.isArray(payload?.response?.reviews) ? payload.response.reviews.length : 0;

              reviews.push(...pageReviews);

              if (dedupeReviews(reviews).length >= reportedTotalReviews) break;
              if (rawReviewCount === 0) break;
            }
          }
        }

        return reviews;
      }

      updateRatingSummary(bottomline) {
        const rating = Number(bottomline?.average_score);
        const count = Number(bottomline?.total_review);
        const summary = this.querySelector('[data-review-rating-summary]');
        const text = summary?.querySelector('[data-review-rating-text]');

        if (!Number.isFinite(rating) || rating <= 0 || !Number.isFinite(count) || count <= 0) return;

        window.JAProductReviewSchema?.update(rating, count);
        if (!summary || !text) return;

        const formattedRating = rating.toFixed(1);
        const reviewLabel = count === 1 ? this.config.text.reviewOne : this.config.text.reviewOther;
        text.textContent = `${formattedRating} / 5 (${count} ${reviewLabel})`;
        summary.setAttribute(
          'aria-label',
          this.config.text.ratingSummary
            .replace('__rating__', formattedRating)
            .replace('__count__', String(count))
            .replace('__review_label__', reviewLabel)
        );
        summary.classList.remove('ja-yotpo-reviews__rating-summary--pending');
        summary.removeAttribute('aria-hidden');
      }

      timestamp(value) {
        const timestamp = value ? Date.parse(value) : 0;
        return Number.isFinite(timestamp) ? timestamp : 0;
      }

      finish(reviews) {
        const grid = this.querySelector('[data-review-grid]');
        const status = this.querySelector('[data-review-status]');
        const sliderTemplate = this.querySelector('[data-review-slider-template]');
        const cta = this.querySelector('[data-review-cta]');
        this.setAttribute('aria-busy', 'false');

        if (!grid || reviews.length === 0) {
          if (status) status.textContent = this.config?.text?.noReviews || '';
          if (!this.config?.designMode) {
            this.hidden = true;
            const section = this.closest('.ja-yotpo-reviews-section');
            section?.setAttribute('hidden', '');

            if (section?.id) {
              document.querySelectorAll('.rating-link').forEach((link) => {
                if (link.getAttribute('href') !== `#${section.id}`) return;
                const rating = link.closest('yotpo-product-rating');
                if (rating) rating.hidden = true;
                else link.hidden = true;
              });
            }
          }
          if (grid) grid.replaceChildren();
          return;
        }

        const sliderContent = sliderTemplate?.content.cloneNode(true);
        const slider = sliderContent?.querySelector('slideshow-component');
        const track = sliderContent?.querySelector('slideshow-slides');

        if (!sliderContent || !slider || !track) {
          if (status) status.textContent = this.config?.text?.unavailable || '';
          return;
        }

        track.setAttribute('role', 'list');
        reviews.forEach((review, index) => {
          const slide = createElement('slideshow-slide', 'ja-yotpo-reviews__slide');
          slide.setAttribute('ref', 'slides[]');
          slide.setAttribute('role', 'listitem');
          slide.setAttribute('aria-hidden', index === 0 ? 'false' : 'true');
          slide.setAttribute('slide-id', `review-${review.id}`);
          slide.style.setProperty('--slideshow-timeline', `--slide-${index}`);
          slide.append(this.renderReview(review));
          track.append(slide);
        });

        slider.style.setProperty(
          '--slideshow-timeline',
          reviews.map((_, index) => `--slide-${index}`).join(', ')
        );
        slider.classList.toggle('ja-yotpo-reviews__carousel--fits-desktop', reviews.length <= 3);

        if (reviews.length <= 1) slider.querySelector('slideshow-arrows')?.remove();

        grid.replaceWith(sliderContent);
        if (cta) cta.hidden = false;
        if (status) status.textContent = '';
      }

      truncateContent(content, limit) {
        if (content.length <= limit) return content;

        const candidate = content.slice(0, limit + 1);
        const lastSpace = candidate.lastIndexOf(' ');
        const cutoff = lastSpace >= Math.floor(limit * 0.6) ? lastSpace : limit;
        return `${content.slice(0, cutoff).trimEnd()}...`;
      }

      renderReview(review) {
        const card = createElement('article', `ja-yotpo-reviews__card ${this.config.cardColorScheme || ''}`);

        const rating = createElement('div', 'ja-yotpo-reviews__stars');
        const roundedScore = Math.max(1, Math.min(5, Math.round(review.score)));
        rating.setAttribute('aria-label', (this.config.text.stars || '__score__ out of 5 stars').replace('__score__', String(review.score)));

        for (let index = 1; index <= 5; index += 1) {
          const className = index <= roundedScore ? 'ja-yotpo-reviews__star' : 'ja-yotpo-reviews__star ja-yotpo-reviews__star--empty';
          rating.append(createStar(className));
        }
        card.append(rating);

        if (this.config.showTitle && review.title) {
          card.append(createElement('h3', 'ja-yotpo-reviews__title', review.title));
        }

        const copy = createElement('div', 'ja-yotpo-reviews__copy');
        const content = createElement('blockquote', 'ja-yotpo-reviews__content', review.content);
        const readMoreLimit = Math.max(1, Number(this.config.readMoreCharacterLimit || 220));
        const canCollapse = Boolean(this.config.enableReadMore) && review.content.length > readMoreLimit;

        if (canCollapse) {
          const collapsedContent = this.truncateContent(review.content, readMoreLimit);
          const contentId = `YotpoReviewContent-${String(this.config.sectionId || 'section').replace(/[^A-Za-z0-9_-]/g, '-')}-${review.id}`;
          const toggle = createElement('button', 'ja-yotpo-reviews__read-more', this.config.text.readMore);
          let expanded = false;

          copy.classList.add('ja-yotpo-reviews__copy--collapsible');
          content.id = contentId;
          content.textContent = collapsedContent;
          toggle.type = 'button';
          toggle.setAttribute('aria-controls', contentId);
          toggle.setAttribute('aria-expanded', 'false');
          toggle.addEventListener('mousedown', (event) => event.stopPropagation());
          toggle.addEventListener('pointerdown', (event) => event.stopPropagation());
          toggle.addEventListener('touchstart', (event) => event.stopPropagation(), { passive: true });
          toggle.addEventListener('click', () => {
            expanded = !expanded;
            content.textContent = expanded ? review.content : collapsedContent;
            toggle.textContent = expanded ? this.config.text.readLess : this.config.text.readMore;
            toggle.setAttribute('aria-expanded', String(expanded));
          });

          copy.append(content, toggle);
        } else {
          copy.append(content);
        }

        card.append(copy);

        const footer = createElement('footer', 'ja-yotpo-reviews__footer');
        const meta = createElement('p', 'ja-yotpo-reviews__meta');

        if (this.config.showReviewerName && review.reviewerName) {
          meta.append(createElement('span', 'ja-yotpo-reviews__meta-item ja-yotpo-reviews__reviewer', review.reviewerName));
        }

        if (this.config.showVerifiedStatus && review.verified) {
          meta.append(createElement('span', 'ja-yotpo-reviews__meta-item ja-yotpo-reviews__verified', this.config.text.verified));
        }

        if (this.config.showDate && review.createdAt) {
          const date = new Date(review.createdAt);
          if (!Number.isNaN(date.getTime())) {
            const formattedDate = new Intl.DateTimeFormat(this.config.locale || document.documentElement.lang || 'en', {
              day: 'numeric',
              month: 'short',
              year: 'numeric',
            }).format(date);
            const time = createElement('time', 'ja-yotpo-reviews__meta-item', formattedDate);
            time.dateTime = review.createdAt;
            meta.append(time);
          }
        }

        if (meta.childElementCount > 0) footer.append(meta);

        if (this.config.showProductName && review.type === 'product' && review.productTitle) {
          footer.append(createElement('p', 'ja-yotpo-reviews__product', review.productTitle));
        }

        if (footer.childElementCount > 0) card.append(footer);
        return card;
      }
    }

    if (!customElements.get('ja-yotpo-reviews')) {
      customElements.define('ja-yotpo-reviews', JAYotpoReviews);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
